import React, { useRef, useCallback } from 'react'

import { Col, Row } from '@enuygun/design-system'

import { serviceCardData } from './data'
import * as S from './ServiceCards.styled'
import { useAppState } from 'context/AppContext'
import { useIsMobile } from 'hooks/useIsMobile'
import { getAnalyticsRequestId } from 'utils/analyticsRequestId'
import sendTrackerLog from 'utils/tracker'

const ServiceCards = () => {
  const { domain, market } = useAppState()
  const domainName = domain === 'tr' ? 'enuygun' : 'wingie'
  const isMobile = useIsMobile()

  const serviceCardsContainerRef = useRef<HTMLDivElement>(null)

  // ServiceCards card click tracking
  const handleServiceCardClick = useCallback(
    (title: string, href: string, order: number) => {
      const environment = isMobile ? 'MOBILE_WEB' : 'DESKTOP_WEB'
      const requestId = getAnalyticsRequestId()

      sendTrackerLog({
        category: domainName === 'enuygun' ? 'enuygun-homepage' : 'wingie-homepage',
        page: domainName === 'enuygun' ? 'enuygun-homepage' : 'wingie-homepage',
        type: 'click',
        message: 'service_card_click',
        environment: environment,
        requestId,
        cardTitle: title,
        linkUrl: href,
        cardOrder: order,
        isMobile: !!isMobile,
        market: market,
      })
    },
    [isMobile, market, domainName]
  )

  return (
    <S.ServiceCardContainer ref={serviceCardsContainerRef}>
      <Row gutter={[8, 16]}>
        {serviceCardData.map(({ icon, title, href }, index) => {
          const itemIndex = index + 1
          return (
            <Col sm={6} key={href}>
              <S.ServiceCard
                href={href}
                target="_blank"
                data-testid={`${domainName}-homepage-serviceCards-item-${itemIndex}-card`}
                onClick={() => handleServiceCardClick(title, href, itemIndex)}
              >
                <S.ServiceImg>{icon}</S.ServiceImg>
                <S.ServiceText data-testid={`${domainName}-homepage-serviceCards-item-${itemIndex}-text`}>{title}</S.ServiceText>
              </S.ServiceCard>
            </Col>
          )
        })}
      </Row>
    </S.ServiceCardContainer>
  )
}

export default ServiceCards
